import axios from 'axios';
import { GHL_CONFIG } from '../components/GHLWidget/ghlConfig';

/**
 * Servicio para comunicación con el servidor MCP
 * Maneja la actualización de contactos en GoHighLevel
 */
export const ghlService = {
  /**
   * Actualiza el contacto en GoHighLevel con las credenciales del usuario
   *
   * IMPORTANTE: Todos los parámetros se pasan explícitamente.
   * El JWT NO se decodifica, se usa solo para autenticación con las APIs.
   *
   * @param {Object} params - Parámetros del contacto
   * @param {string} params.contactId - ID del contacto en GHL
   * @param {string} params.jwt - Token JWT del usuario para autenticación
   * @param {string} params.email - Email del usuario (pasado explícitamente)
   * @param {string} params.first_name - Nombre del usuario (pasado explícitamente)
   * @param {string} params.last_name - Apellido del usuario (pasado explícitamente)
   * @param {string} params.username - Nombre del usuario (pasado explícitamente)
   * @param {string} params.externalid - ID del usuario (pasado explícitamente)
   * @returns {Promise<Object>} Resultado de la operación
   */
  async updateContact({ contactId, jwt, email, first_name, last_name, username, externalid }) {
    console.log("=".repeat(70));
    console.log("📤 INICIANDO ACTUALIZACIÓN DE CONTACTO EN GHL");
    console.log("=".repeat(70));

    // Validar parámetros requeridos
    if (!contactId) {
      console.error("❌ contactId es requerido");
      return { success: false, error: "contactId es requerido" };
    }

    if (!jwt) {
      console.error("❌ jwt es requerido");
      return { success: false, error: "jwt es requerido" };
    }

    if (!email) {
      console.error("❌ email es requerido");
      return { success: false, error: "email es requerido" };
    }

    if (!first_name) {
      console.error("❌ first_name es requerido");
      return { success: false, error: "first_name es requerido" };
    }

    if (!last_name) {
      console.error("❌ last_name es requerido");
      return { success: false, error: "last_name es requerido" };
    }

    if (!username) {
      console.error("❌ username es requerido");
      return { success: false, error: "username es requerido" };
    }

    if (!externalid) {
      console.error("❌ externalid es requerido");
      return { success: false, error: "externalid es requerido" };
    }

    try {
      console.log("📋 Datos de entrada:");
      console.log("   - Contact ID:", contactId);
      console.log("   - JWT (primeros 50 chars):", jwt.substring(0, 50) + "...");
      console.log("   - Email:", email);
      console.log("   - First Name:", first_name);
      console.log("   - Last Name:", last_name);
      console.log("   - Username:", username);
      console.log("   - User ID (externalid):", externalid);
      console.log("-".repeat(70));

      const payload = {
        contact_id: contactId,
        jwt: jwt,
        email: email,
        first_name: first_name,
        last_name: last_name,
        username: username,
        externalid: externalid
      };

      console.log("📦 Payload que se enviará al MCP Server:");
      console.log(JSON.stringify({
        contact_id: payload.contact_id,
        jwt: payload.jwt.substring(0, 50) + "...",
        email: payload.email,
        first_name: payload.first_name,
        last_name: payload.last_name,
        username: payload.username,
        externalid: payload.externalid
      }, null, 2));
      console.log("-".repeat(70));
      console.log("🚀 Enviando request a:", GHL_CONFIG.MCP_SERVER_URL);

      const response = await axios.post(GHL_CONFIG.MCP_SERVER_URL, payload, {
        headers: {
          'Content-Type': 'application/json'
        },
        timeout: 10000 // 10 segundos timeout
      });

      console.log("📨 Respuesta recibida:");
      console.log("   - Status:", response.status);
      console.log("   - Status Text:", response.statusText);
      console.log("📄 Response body:");
      console.log(JSON.stringify(response.data, null, 2));

      if (response.data.success) {
        console.log("=".repeat(70));
        console.log("✅ CONTACTO ACTUALIZADO EXITOSAMENTE");
        console.log("=".repeat(70));
        return { success: true, data: response.data };
      } else {
        console.log("=".repeat(70));
        console.error("❌ ERROR AL ACTUALIZAR CONTACTO");
        console.log("=".repeat(70));
        console.error("   - Status:", response.status);
        console.error("   - Error:", response.data.error || response.data.message);
        console.log("=".repeat(70));
        return { success: false, error: response.data.error || response.data.message };
      }
    } catch (error) {
      console.log("=".repeat(70));
      console.error("❌ ERROR DE RED O EXCEPCIÓN");
      console.log("=".repeat(70));

      if (error.response) {
        // El servidor respondió con un código de error
        console.error("   - Status:", error.response.status);
        console.error("   - Data:", error.response.data);
        console.error("   - Headers:", error.response.headers);
      } else if (error.request) {
        // La petición fue hecha pero no hubo respuesta
        console.error("   - No se recibió respuesta del servidor");
        console.error("   - Request:", error.request);
      } else {
        // Algo ocurrió al configurar la petición
        console.error("   - Error:", error.message);
      }

      console.log("=".repeat(70));
      return {
        success: false,
        error: error.response?.data?.error || error.message || "Error desconocido"
      };
    }
  }
};
